import React from "react";

export default function Base({}) {
	return <>
		<path d="M21.475,99.992c-6.648,0-12.964-6.852-13.958-13.207L0.011-0.008l88.112,5.649c6.212,0.931,11.096,6.804,11.104,13.848  l0.762,80.503H21.475z M85.706,85.71l-0.544-57.492c-0.005-5.029-3.495-9.233-7.931-9.898l-62.938-4.03l5.36,61.98  c0.71,4.536,5.222,9.44,9.971,9.44H85.706z"/>
	</>
}